import { COUNTRIES } from '@nv/react-commons/src/Constants'

export const getMaxDimensions = (country = '') => {
  switch (country && country.toLowerCase()) {
    case COUNTRIES.SG:
      return 300
    case COUNTRIES.TH:
      return 200
    case COUNTRIES.VN:
      return 240
    case COUNTRIES.PH:
      return 150
    default:
      return 180
  }
}

export const getDefaultDimensions = (country = '') => {
  switch (country && country.toLowerCase()) {
    case COUNTRIES.MY:
    case COUNTRIES.TH:
    case COUNTRIES.VN:
    case COUNTRIES.PH:
    case COUNTRIES.ID:
      return [10, 25, 10]
    default:
      return []
  }
}

export const hasDimensionSize = (country = '') => {
  switch (country && country.toLowerCase()) {
    case COUNTRIES.SG:
    case COUNTRIES.MA:
      return false
    default:
      return true
  }
}
